import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, Plus } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { SERVICIOS } from "../data/content";
import { scrollToHash } from "./Navbar";

export const Servicios = () => {
  const [active, setActive] = useState(0);

  return (
    <section
      id="servicios"
      data-testid="servicios-section"
      className="relative bg-white py-20 sm:py-28 lg:py-36"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-12 gap-12 px-4 sm:px-6 lg:px-8">
        <div className="col-span-12 lg:col-span-7">
          <SectionHead
            num="03"
            eyebrow="Capacidades"
            title="Nuestros servicios"
            testId="servicios-head"
          />

          <div className="mt-14 border-t border-cafe-line">
            {SERVICIOS.map((s, i) => {
              const isOpen = active === i;
              return (
                <Reveal key={s.title} delay={0.05 * i}>
                  <div className="border-b border-cafe-line" data-testid={`servicio-item-${i + 1}`}>
                    <button
                      data-testid={`servicio-toggle-${i + 1}`}
                      onClick={() => setActive(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="group flex w-full items-center gap-5 py-6 text-left sm:gap-8"
                    >
                      <span
                        className={`font-mono text-xs font-semibold tracking-[0.25em] transition-colors duration-300 ${
                          isOpen ? "text-cafe" : "text-cafe-muted/60 group-hover:text-cafe"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span
                        className={`flex-1 font-display text-xl font-semibold leading-snug transition-colors duration-300 sm:text-2xl lg:text-3xl ${
                          isOpen ? "text-cafe" : "text-cafe-dark group-hover:text-cafe"
                        }`}
                      >
                        {s.title}
                      </span>
                      <motion.span
                        animate={{ rotate: isOpen ? 45 : 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                          isOpen
                            ? "border-cafe bg-cafe text-white"
                            : "border-cafe-line text-cafe-dark group-hover:border-cafe"
                        }`}
                      >
                        <Plus className="h-4 w-4" />
                      </motion.span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                          className="overflow-hidden"
                        >
                          <div className="pb-8 pl-10 pr-2 sm:pl-16">
                            <p
                              data-testid={`servicio-desc-${i + 1}`}
                              className="max-w-xl text-sm leading-relaxed text-cafe-muted sm:text-base"
                            >
                              {s.text}
                            </p>
                            <button
                              data-testid={`servicio-cta-${i + 1}`}
                              onClick={() => scrollToHash("#contacto")}
                              className="group/cta mt-5 flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-cafe transition-colors duration-300 hover:text-cafe-dark"
                            >
                              Solicitar cotización
                              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover/cta:translate-x-1" />
                            </button>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <div className="col-span-12 hidden lg:col-span-5 lg:block">
          <div className="sticky top-28">
            <Reveal delay={0.2}>
              <div className="relative">
                <div aria-hidden="true" className="absolute -right-4 -top-4 h-full w-full border border-cafe" />
                <div className="relative overflow-hidden">
                  <img
                    src="/img/servicios.webp"
                    alt="Edificio en construcción con andamios perimetrales"
                    data-testid="servicios-image"
                    className="h-[560px] w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-cafe-dark/10" />
                </div>
                <p className="mt-4 border-t border-cafe-line pt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-cafe-muted">
                  Trabajos especializados in-house
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
